import uniq from "lodash/uniq";
import { useProducts } from "../useProducts";

export const useUnits = () => {
  const { products } = useProducts();
  const units = products
    .flatMap((p) => p.options)
    .map((o) => o.unit)
    .filter((u): u is string => u !== undefined);
  const uniqUnits = uniq(units);
  return { units: uniqUnits };
};
